import { queryOptions } from "@tanstack/react-query";
import { fetchOccPageData } from "./pageDataClient";
import { pageDataKeys } from "./pageDataKeys";
import type { PageInitialDataResult } from "./pageInitialDataTypes";
import type { CompleteRegistrationPageInitialData } from "./registeredUserCompletePageInitialData";

const REGISTERED_USER_COMPLETE_PAGE_ID = "registered/user/complete";

export interface RegisteredUserCompleteSearch {
  token?: string;
  affiliateId?: string;
}

function buildPath(search: RegisteredUserCompleteSearch): string {
  const params = new URLSearchParams();
  if (search.token !== undefined) {
    params.set("token", search.token);
  }
  if (search.affiliateId !== undefined) {
    params.set("affiliateId", search.affiliateId);
  }
  const query = params.toString();
  return `/page-data/${REGISTERED_USER_COMPLETE_PAGE_ID}${query ? `?${query}` : ""}`;
}

export const registeredUserCompletePageQueryOptions = (search: RegisteredUserCompleteSearch) =>
  queryOptions({
    queryKey: [...pageDataKeys.page(REGISTERED_USER_COMPLETE_PAGE_ID), search],
    queryFn: () =>
      fetchOccPageData<PageInitialDataResult<CompleteRegistrationPageInitialData>>(buildPath(search)),
    staleTime: 0,
    gcTime: 0,
    refetchOnWindowFocus: false,
    retry: 1,
  });
